import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import compose from 'recompose/compose';
import { connect } from "react-redux";
import validate from 'validate.js';
import _ from 'underscore';

// Material helpers
import { 
  withStyles, 
  Dialog, 
  DialogActions, 
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';

// Material components
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  TablePagination,
  Typography,
  Button,
  FormControlLabel,
  TableSortLabel,
  FormGroup
} from '@material-ui/core';

// Material icons
import {
  EditOutlined as EditIcon
} from '@material-ui/icons';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { red, blue } from '@material-ui/core/colors'

// Shared components
import { 
  Portlet, 
  PortletContent, 
  PortletHeader, 
  PortletLabel, 
  PortletToolbar,
  Status
} from 'components';
import { addCid, deleteCid, getCids } from "../../../../actions/authActions";

import { TrendChart } from "../../../Dashboard/components";
import { SearchInput } from 'components';

// Component styles
import styles from './styles';
import schema from './schema';

const buttomTheme = createMuiTheme({ 
  palette: { 
    primary: blue,
    secondary: red
  } 
})

const adminColumnTitles = [
  'name',
  'action'
];

const headCells = {
  name:          {label:"Name", id: "name", sortable: "true" },
  action:        {label:"Action", id: "action", sortable: "false" },
}

class CidTable extends Component {
  state = {
    rowsPerPage: 10,
    page: 0,
    dialogOpen: '',
    currentCid: '',
    cids: [],
    order: 'desc',
    orderBy: 'name',
    values: {
      name: '',
    },
    touched: {
      name: false,
    },
    errors: {
      name: null,
    },
    isValid: false,
  };

  constructor(props) {
    super(props);
    this.handleClickOpenCidDialog = this.handleClickOpenCidDialog.bind(this);
    this.handleCloseDialog = this.handleCloseDialog.bind(this);
    this.handleClickOpenCidChart = this.handleClickOpenCidChart.bind(this);
  }

  componentDidMount () {
    this.updateCidTable();
  }

  async updateCidTable () {
    await this.props.getCids();
    let cids = this.props.auth.cids
    console.log(cids)
    this.setState({cids})
  }

  handleClickOpenCidDialog() {
    this.setState({dialogOpen:'addCid'});
  }

  handleClickOpenCidChart(cid) {
    this.setState({
      currentCid:cid,
      dialogOpen:'cidChart'
    });
  }

  handleCloseDialog() {
    this.setState({
      dialogOpen:'',
      currentCid: '',
      values: {
        name: '',
      }
    });
  }

  handleAddCid = async () => {
    try {
      const { name } = this.state.values;
      this.props.addCid(name).then(()=>{
        this.updateCidTable();
        this.handleCloseDialog();
      });
    } catch (error) {
      console.error(error);
    }
  };

  handleDeleteCid = async (cid) => {
    try {
      this.props.deleteCid(cid).then(()=>{
        this.updateCidTable();
      });
    } catch (error) {
      console.error(error);
    }
  }; 

  validateForm = _.debounce(() => {
    const { values } = this.state;

    const newState = { ...this.state };
    const errors = validate(values, schema);

    newState.errors = errors || {};
    newState.isValid = errors ? false : true;

    this.setState(newState);
  }, 300);

  handleFieldChange = (field, value) => {
    const newState = { ...this.state };
    newState.values[field] = value;
    newState.touched[field] = true;
    this.setState(newState, this.validateForm);
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleSearchCid(searchKey) {
    const { cids } = this.props.auth;
    let newCids = cids.filter(cid => {
      if(cid.name.includes(searchKey))
        return true;
      return false;
    })
    console.log(searchKey);
    this.setState({cids:newCids});
  }

  renderCidRow = cid => {
    const {classes} = this.props;
    return (
      <TableRow
        className={classes.tableRow}
        hover
        key={cid.name}
      >
        <TableCell className={classes.tableCell} align="left">
          <div className={classes.tableCellInner}>
            <Link
              component="button"
              onClick={() => {
                this.handleClickOpenCidChart(cid.name);
              }} 
            >
              {cid.name}
            </Link>
          </div>
        </TableCell>
        <TableCell className={classes.tableCell}>
          <MuiThemeProvider theme={buttomTheme}>
            <Button
              color='secondary'
              size="small"
              variant="outlined"
              onClick={()=>
                this.handleDeleteCid(cid.name)
              }
            >
              Delete
            </Button>
          </MuiThemeProvider>
        </TableCell>
      </TableRow>
    );
  }

  renderAddCidDialog = () => {
    const {classes} = this.props;
    const { values, touched, errors, isValid, dialogOpen } = this.state;
    const showNameError = touched.name && errors.name;
    return (
      <Dialog open={dialogOpen === 'addCid'} onClose={this.handleCloseDialog} className={classes.cidDialog}>
        <DialogTitle id="form-dialog-title">Add New Customer ID</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please specify customer ID
          </DialogContentText>
          <TextField
            className={classes.textField}
            label="Customer ID"
            name="name"
            onChange={event =>
              this.handleFieldChange('name', event.target.value)
            }
            value={values.cid}
            variant="outlined"
            placeholder="example-customer-id"
            InputLabelProps={{
              shrink: true,
            }}
          />
          {showNameError && (
            <Typography
              className={classes.fieldError}
              variant="body2"
            >
              {errors.name[0]}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCloseDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={this.handleAddCid} disabled={!isValid} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  renderCidChart() {
    const { classes } = this.props;
    const { cids } = this.props.auth;
    const {currentCid, dialogOpen} = this.state;
    const target = cids.filter(cid => {
      return cid.name === currentCid;
    })
    let time = new Date()
    console.log(currentCid, target)
    const cidName = (target.length > 0) ? target[0].name : '';
    return (
      <Dialog open={dialogOpen === 'cidChart'} onClose={this.handleCloseDialog} fullWidth>
        <DialogTitle id="form-dialog-title">Customer ID: {cidName} </DialogTitle>
        <DialogContent>
          <TrendChart className={classes.item} timeRange={0} lastUpdated={time} cids={target} title={"Impression Trend"}/>
        </DialogContent>
      </Dialog>
    )
  }

  render() {
    function desc(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
        return 1;
      }
      return 0;
    }
    function getSorting(order, orderBy) {
      return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
    }
    const { classes, className} = this.props;
    const { rowsPerPage, page, cids, order, orderBy } = this.state;
    const columnTitles = adminColumnTitles;
    const rootClassName = classNames(classes.root, className);
    //const sorted = cids.sort(getSorting(order, orderBy))
    const sorted = cids
    const cidsTotal = cids.length;

    const createSortHandler = property => event => {
      const isDesc = orderBy === property && order === 'desc';
      this.setState({ order: isDesc ? 'asc' : 'desc', orderBy: property })
    };

    return (
      <Portlet className={rootClassName}>
        {this.renderCidChart()}
        {this.renderAddCidDialog()}
        <PortletHeader noDivider>
          <PortletLabel
            subtitle={`${cidsTotal} in total`}
            title="Customer IDs"
          />
          <SearchInput
            className={classes.searchInput}
            placeholder="Search customer ID"
            onChange={event =>
              this.handleSearchCid(event.target.value)
            }
          />
          <PortletToolbar>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Button
                    className={classes.newEntryButton}
                    color="primary"
                    size="small"
                    variant="outlined"
                    onClick={this.handleClickOpenCidDialog}
                  >
                    New Customer ID
                  </Button>
                }
              />
            </FormGroup>
          </PortletToolbar>
        </PortletHeader>
        <PortletContent noPadding>
          <PerfectScrollbar>
            <Table>
              <TableHead>
                <TableRow>
                  {
                    columnTitles.map(title=>{
                      const head = headCells[title];
                      return (
                        <TableCell 
                          align="left"
                          sortDirection={orderBy === head.id ? order : false}
                        >
                          {head.sortable ?
                            <TableSortLabel
                              active={orderBy === head.id}
                              direction={order}
                              onClick={createSortHandler(head.id)}
                            >
                              {head.label}
                              {orderBy === head.id ? (
                                <span className={classes.visuallyHidden}>
                                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                              ) : null}
                            </TableSortLabel>
                            : head.label
                          }
                        </TableCell>
                      );
                    })
                  }
                </TableRow>
              </TableHead>
              <TableBody>
                {sorted
                  .slice(page*rowsPerPage, (page+1)*rowsPerPage)
                  .map(cid => {
                    return this.renderCidRow(cid)
                  })}
              </TableBody>
            </Table>
          </PerfectScrollbar>
          <TablePagination
            backIconButtonProps={{
              'aria-label': 'Previous Page'
            }}
            component="div"
            count={cids.length}
            nextIconButtonProps={{
              'aria-label': 'Next Page'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </PortletContent>
      </Portlet>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
});

CidTable.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onShowDetails: PropTypes.func,
  addCid: PropTypes.func.isRequired,
  deleteCid: PropTypes.func.isRequired,
  getCids: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps,{addCid,deleteCid,getCids})
)(CidTable);
